<template>
  <DashboardLayout>

    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <p class="mb-0 main-identifier fw-semibold">Appraisal</p>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Create Approval Authority</p>
    </div>

    <div class="d-flex justify-content-center">

      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">

            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Create Approval Authority</h1>
              </div>

              <div class="form-body">
                <div class="row mt-2 mb-3">
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label for="year"
                        class="form-label">Name</label></div>
                    <div class="col-md-9 input-right">
                      <input type="text" class="form-control" v-model="approval_name" placeholder="" required>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="subsector" class="form-label">Description</label></div>
                    <div class="col-md-9 input-right">
                      <div class="col-md-12 input-right">
                        <textarea class="form-control" id="description" v-model="description" placeholder="" rows="3"
                          required></textarea>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="subsector" class="form-label">No. of Unique Position</label></div>
                    <div class="col-md-9 input-right">
                      <input type="number" class="form-control" v-model="position" inputmode="numeric"
                        pattern="[0-9,]*" @keypress="onlyDigitsAndComma" placeholder="" required>
                    </div>
                  </div>

                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="unlimitedApproval" class="form-label">Unlimited Approval</label></div>
                    <div class="col-md-9 input-right">
                      <label class="unlimited-toggle" for="unlimitedApproval">
                        <input type="checkbox" id="unlimitedApproval" v-model="unlimitedApproval"
                          @change="onUnlimitedApprovalChange">
                        <span class="unlimited-toggle-track"><span class="unlimited-toggle-thumb"></span></span>
                        <span class="unlimited-toggle-text">This approval authority has no approval limit</span>
                      </label>
                    </div>
                  </div>

                  <div v-if="!unlimitedApproval"
                    class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="subsector" class="form-label">Approval Limit Per Quarter</label></div>
                    <div class="col-md-9 input-right">
                      <input type="number" class="form-control" v-model="approval_limit" inputmode="numeric"
                        pattern="[0-9,]*" @keypress="onlyDigitsAndComma" placeholder="" required>
                    </div>
                  </div>

                  <div v-if="!unlimitedApproval"
                    class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center"><label
                        for="subsector" class="form-label">Approval Amount Per Quarter (₦)</label></div>
                    <div class="col-md-9 input-right">
                      <input type="text" class="form-control" :value="formatNumber(approval_amount)" inputmode="numeric"
                        pattern="[0-9,]*" @keypress="onlyDigitsAndComma" @input="onAmountApprovalInput" placeholder=""
                        required>
                    </div>
                  </div>
                </div>

                <div class="d-flex justify-content-center ">
                  <button type="submit" class="btn btn-primary submit-btn" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status"
                      aria-hidden="true"></span>
                    {{ (loading ? 'Submitting...' : 'Submit') }}
                  </button>
                </div>
              </div>
            </div>


          </div>
        </form>
      </div>
    </div>

  </DashboardLayout>
</template>

<script setup>
import { ref , onMounted} from 'vue'
import axios from 'axios'
import DashboardLayout from '../layout/DashboardLayout.vue'
import Swal from 'sweetalert2'
import Cookies from 'js-cookie';

const root_api_url = process.env.VUE_APP_API_ROOT_URL

const approval_name = ref('')
const description = ref('')
const position = ref('')
const approval_limit = ref('')
const approval_amount = ref('')
const unlimitedApproval = ref(false)

const loading = ref(false)


const handleSubmit = async () => {
  const token = Cookies.get('auth_token');

  const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
  const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

  const ApprovalAuthorityData = {
    name: approval_name.value,
    description: description.value,
    uniquePositionInd: position.value,
    limitPerQtr: approval_limit.value,
    approvalAmtPerQtr: approval_amount.value,
    unlimitedApprovalInd: unlimitedApproval.value ? 1 : 0,
  };
  loading.value = true;

  // console.log("inside Appauth data", ApprovalAuthorityData)

  try {
    const result = await axios.post(`${root_api_url}/eli/app-auth`, ApprovalAuthorityData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (result.status === 201) {
      Swal.fire({
        html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Approval Authority Created Successfully</p> `,
        showConfirmButton: true,
        showCloseButton: true,
        icon: undefined,
      });
      approval_name.value = '';
      description.value = '';
      position.value = '';
      approval_limit.value = '';
      approval_amount.value = '';
      unlimitedApproval.value = false;
    }
  } catch (error) {
    // Swal.fire({
    //   html: `${iconHtmlError}
    //   <h1 style="font-weight:600;">Error</h1>
    //   <p>Failed to create approval authority</p>`,
    //   showConfirmButton: true,
    //   showCloseButton: true,
    //   icon: undefined,
    // });
    // console.error('Submission error:', err)
    // alert('Failed to create MDA: ' + (err.response?.data?.message || err.message))

    if (error.response) {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>${error?.response?.data?.errorMessage || error?.response?.data?.error || 'Unexpected error occurred, kindly contact administrator.'}</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      } else {
        Swal.fire({
          html: `${iconHtmlError}
        <h1 style="font-weight:600;">Error</h1>
        <p>Unexpected error occurred, kindly contact administrator.</p>`,
          showConfirmButton: true,
          showCloseButton: true,
          icon: undefined,
        });
      }
   } finally {
    loading.value = false; // Stop loading
  }
}

function onUnlimitedApprovalChange() {
  if (unlimitedApproval.value) {
    approval_amount.value = 0
    approval_limit.value = 0
  }
}

function formatNumber(val) {
  return Number(val || 0).toLocaleString();
}

/**
 * Block keys other than digits, comma, or navigation
 */
function onlyDigitsAndComma(e) {
  const k = e.key;
  if (
    (k >= '0' && k <= '9') ||
    k === ',' || k === '.' ||
    ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'].includes(k)
  ) return;
  e.preventDefault();
}

/**
 * Handle the “Amount Approved” input:
 * - strip non‑digits
 * - update the numeric model
 * - re‑format the visible field
 */
function onAmountApprovalInput(e) {
  const digits = e.target.value.replace(/[^\d]/g, '');
  approval_amount.value = digits === '' ? 0 : Number(digits);
  e.target.value = formatNumber(approval_amount.value);
}

onMounted(() => {
  document.title = "Create Approval Authority"
})

</script>

<style scoped>
.unlimited-toggle {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  margin-bottom: 0;
  user-select: none;
}

.unlimited-toggle input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.unlimited-toggle-track {
  position: relative;
  flex-shrink: 0;
  width: 46px;
  height: 24px;
  background-color: #ccc;
  border-radius: 999px;
  transition: background-color 0.2s ease-in-out;
}

.unlimited-toggle-thumb {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
  transition: transform 0.2s ease-in-out;
}

.unlimited-toggle input:checked + .unlimited-toggle-track {
  background-color: #4caf50;
}

.unlimited-toggle input:checked + .unlimited-toggle-track .unlimited-toggle-thumb {
  transform: translateX(22px);
}

.unlimited-toggle input:focus-visible + .unlimited-toggle-track {
  outline: 2px solid #4caf50;
  outline-offset: 2px;
}

.unlimited-toggle-text {
    color: var(--color);
  font-size: 0.95rem;
}
</style>
